import { useState } from 'react'
import { usePostImage } from 'src/components/postCard/hooks'
import Loading from 'src/components/Loading'
import { MediaLightboxType } from 'src/components'
import { useMediaLightbox } from 'src/context'
import { Wrapper } from './feedCardImage.styles'
import { FeedCardImageProps } from './feedCardImage.types'

const FeedCardImage = ({ post, className }: FeedCardImageProps) => {
  const [hasLoadingError, setHasLoadingError] = useState(false)
  const { data: src, isError, isLoading } = usePostImage({ post })
  const { onOpenLightbox } = useMediaLightbox()

  const isEmptyImage = src?.includes('default_placeholder.png') || !src || hasLoadingError

  const handleOpenLightbox = () => {
    onOpenLightbox({
      type: MediaLightboxType.IMAGE,
      src
    })
  }

  const handleError = () => {
    setHasLoadingError(true)
  }

  if (isLoading) {
    return (
      <Wrapper className={className}>
        <Loading full />
      </Wrapper>
    )
  }

  if (isError || isEmptyImage) {
    return null
  }

  return (
    <Wrapper className={className}>
      <img
        src={src}
        alt={post.title}
        loading="lazy"
        className="_w-full _position-absolute _cursor-pointer"
        onClick={handleOpenLightbox}
        onError={handleError}
      />
    </Wrapper>
  )
}

export default FeedCardImage
